import createVueApp from '@/common/create_app'

// Styxie derives name from Admin::MobileAppVersions::VersionsController → AdminMobileAppVersionsVersions
Styxie.Initializers.AdminMobileAppVersionsVersions = {
  index: async(props) => {
    const { default: IndexPage } = await import('@/vue_widgets/admin/mobile_app_versions/index/index.vue')
    createVueApp(IndexPage, { props })
  },
  show: async(props) => {
    const { default: ShowPage } = await import('@/vue_widgets/admin/mobile_app_versions/show/index.vue')
    createVueApp(ShowPage, { props })
  },
  new: async(props) => {
    const { default: FormPage } = await import('@/vue_widgets/admin/mobile_app_versions/form.vue')
    createVueApp(FormPage, { props })
  },
  edit: async(props) => {
    const { default: FormPage } = await import('@/vue_widgets/admin/mobile_app_versions/form.vue')
    createVueApp(FormPage, { props })
  }
}
